import {http} from "../core/services/http";
import {IContactUsRequest, IUpdateContactUsRequest} from "../core/interfaces";
import {Pagination, PaginationParams} from "../core/services/utils";

type ContactUsParams = PaginationParams & { includeSolved?: boolean }

export const getAllContactUsRequests = (params?: ContactUsParams) =>
    http.get<Pagination<IContactUsRequest>>('/api/dashboard/contact-us', {params})

export const updateContactUsRequest = (id: string, data: IUpdateContactUsRequest) =>
    http.put(`/api/dashboard/contact-us/${id}`, data)
